import { render, staticRenderFns } from "./AuthLogoutLink.vue?vue&type=template&id=76ab8197"
import script from "./AuthLogoutLink.vue?vue&type=script&lang=js"
export * from "./AuthLogoutLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76ab8197')) {
      api.createRecord('76ab8197', component.options)
    } else {
      api.reload('76ab8197', component.options)
    }
    module.hot.accept("./AuthLogoutLink.vue?vue&type=template&id=76ab8197", function () {
      api.rerender('76ab8197', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AuthLogoutLink.vue"
export default component.exports